import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAdmin } from "@/context/AdminContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.user);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-navy px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-cream rounded-lg p-8">
        <div className="text-center">
          <span className="font-display text-3xl text-navy">JOHNNY<span className="text-brick">MART</span></span>
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-bold">Admin</p>
        </div>
        <div className="mt-8 flex items-center gap-2 text-navy font-display text-xl">
          <Lock className="w-5 h-5 text-brick" /> Sign in
        </div>
        <label className="block text-sm font-bold text-navy uppercase mt-5">Email</label>
        <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 w-full rounded-md border border-navy/20 px-4 py-3 outline-none focus:border-brick" />
        <label className="block text-sm font-bold text-navy uppercase mt-4">Password</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 w-full rounded-md border border-navy/20 px-4 py-3 outline-none focus:border-brick" />
        <button data-testid="admin-login-btn" disabled={loading} className="mt-6 w-full bg-brick text-white font-bold uppercase rounded-md py-3.5 hover:bg-navy transition-colors disabled:opacity-60">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
